"use client";

import { useMemo } from "react";

import { Building2, MapPin, SignpostBig } from "lucide-react";

import { AutocompleteItem } from "@/components/ui/Forms/AutocompleteList";
import { useManualLocalizedFieldValue } from "@/hooks/useManualLocalizedFieldValue";
import { Region } from "@/services/search.service";
import { autocompleteBuildLocationOptions } from "@/utils/autocompleteBuildLocationOptions";

export const useAutocompleteLocationOptions = (
  regionsListData?: Region[],
  locale?: string,
) => {
  const translate = useManualLocalizedFieldValue();

  return useMemo(() => {
    return autocompleteBuildLocationOptions({
      regionsListData,
      locale: locale ?? "en",
      t: translate,
      icons: {
        region: <MapPin className="w-8 h-8 text-[#323232]" />,
        city: <Building2 className="w-8 h-8 text-[#323232]" />,
        district: <Building2 className="w-8 h-8 text-[#323232]" />,
        microdistrict: <Building2 className="w-8 h-8 text-[#323232]" />,
        street: <SignpostBig className="w-8 h-8 text-[#323232]" />,
        metroStation: <Building2 className="w-8 h-8 text-[#323232]" />,
      },
    });
  }, [regionsListData, locale, translate]);
};

export const useAutocompleteFilteredOptions = (
  options: AutocompleteItem[],
  searchString: string,
  minSymbolsToTrigger: number = 1,
) => {
  return useMemo(() => {
    const searchLower = searchString.trim().toLowerCase();
    if (searchLower.length < minSymbolsToTrigger) return [];

    return options.filter((item) =>
      item.title.toLowerCase().includes(searchLower),
    );
  }, [searchString, minSymbolsToTrigger, options]);
};
